import { ToastContainer } from "react-toastify";
import RouterData from "./Routes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./Api/queryClient";

function App() {
  return (
    <>
      {/* <QueryClientProvider client={queryClient}> */}
      <RouterData />
      <ToastContainer newestOnTop />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      {/* </QueryClientProvider> */}
    </>
  );
}

export default App;
